const pagination = (data, page) => {
    return data.slice(0,page)
};


const getQueryStringValue = (key) => {
  return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

export {
  pagination,
  getQueryStringValue,
}
